import { BasicStorageItem, ServiceProvider, StorageItem } from '@uploadcam/common';
import { StorageGetNextListPage, StorageListPage } from './list-page';
import { StorageManager } from './manager';

export const DEFAULT_PAGE_SIZE = 100;

export type StorageItemId = string & {};

export interface StorageCapabilities {
  previewThumbnails: boolean;
  userGroups: boolean;
}

export type FeedItemUrlMap = Record<string, string | undefined>;

export interface FeedItemsImageUrls {
  thumbnails: FeedItemUrlMap;
  previews: FeedItemUrlMap;
}

export interface StorageAdapter extends StorageGetNextListPage {
  /**
   * Pass reference to the wrapper Manager
   *
   * This is needed so the Pagination object uses
   * the Manager instead of the Adapter
   */
  setManager(manager: StorageManager): void;
  /** Returns a list of optional features that the Storage implements */
  getCapabilities(): StorageCapabilities;
  /** Returns the service provider of the adapter */
  getProvider(): ServiceProvider;
  getRootFolder(): Promise<StorageItem>;
  // TODO: Replace this to fetch file `name` metadata
  getThumbnailUrls(items: readonly BasicStorageItem[]): Promise<FeedItemUrlMap>;
  getPreviewUrls(items: readonly BasicStorageItem[]): Promise<FeedItemUrlMap>;
  getDownloadUrls(items: readonly BasicStorageItem[]): Promise<FeedItemUrlMap>;
  getFileUrl(file: StorageItem): Promise<string>;
  getFolderUrl(folder: StorageItem): Promise<string>;
  getProviderUrl(): string;
  /** Updates the access token */
  updateAccessToken(token: string): void;
  write(parent: StorageItem, file: File): Promise<StorageItem>;
  createFolder(parent: StorageItem, name: string): Promise<StorageItem>;
  /**
   * Renames a folder to `name`, keeping it in the same parent.
   *
   * Throws a `FriendlyError` with key `folderNameConflict` when a sibling with
   * the same name already exists (we don't silently auto-rename).
   */
  renameFolder(folder: StorageItem, name: string): Promise<StorageItem>;
  listFolder(item: StorageItem, onlyFolders?: boolean): Promise<StorageListPage>;
  moveItems(
    targetFolder: StorageItem,
    items: StorageItem[],
  ): Promise<Record<StorageItemId, boolean>>;
  trashItems(items: StorageItem[]): Promise<Record<StorageItemId, boolean>>;
  setCaption(item: Readonly<StorageItem>, caption?: string): Promise<void>;
}
